import { Grid, Grow, IconButton, LinearProgress, Paper, Stack, Step, StepConnector, stepConnectorClasses, StepIconProps, StepLabel, Stepper, styled, Typography } from "@mui/material";

export const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 30,
  },

  [`& .${stepConnectorClasses.line}`]: {
    position: 'relative',
    overflow: 'hidden',

    height: 3,
    border: 0,
    borderRadius: 1,
    backgroundColor: '#eaeaf0',

    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),

    '&::before': {
      content: '""',

      position: 'absolute',
      inset: 0,

      backgroundImage:
        'linear-gradient(95deg, #FFD450 10%, #60A5FA 60%, #165FAB 100%)',

      width: '0%',
      transition: 'width 300ms ease',
    },
  },

  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}::before`]:
    {
      width: '100%',
    },

  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}::before`]:
    {
      width: '100%',
    },
}));

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme }) => ({
  position: 'relative',

  width: 60,
  height: 60,

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  borderRadius: '50%',

  backgroundColor: '#ccc',
  color: '#fff',

  overflow: 'hidden',
  zIndex: 1,

  ...theme.applyStyles('dark', {
    backgroundColor: theme.palette.grey[700],
  }),

  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,

    backgroundImage:
      'linear-gradient(90deg, #165DAB 0%, #60A5FA 50%, #FFD450 100%)',

    /* key part */
    clipPath: 'inset(0 100% 0 0)',

    transition: 'clip-path 350ms cubic-bezier(0.4, 0, 0.2, 1)',
    transitionDelay: '200ms',
  },

  '& > *': {
    position: 'relative',
    zIndex: 2,
  },

  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        boxShadow: '1px 4px 6px rgba(0,0,0,.25)',

        '&::before': {
          clipPath: 'inset(0 0 0 0)',
        },
      },
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        boxShadow: '1px 4px 8px rgba(0,0,0,.25)',
        cursor: 'pointer',
        '&::before': {
          clipPath: 'inset(0 0 0 0)',
        },
      },
    },
  ],
}));

export function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;
  const icons: { [index: string]: React.ReactElement<unknown> } = {
    1: <IconButton disabled={!completed && !active} sx={{color: 'white', width: '100%', height: '100%', textShadow: completed || active ? '1px 1px 2px rgb(0, 0, 0)' : 'none'}}>1</IconButton>,
    2: <IconButton disabled={!completed && !active} sx={{color: 'white', width: '100%', height: '100%', textShadow: completed || active ? '1px 1px 2px rgb(0, 0, 0)' : 'none'}}>2</IconButton>,
    3: <IconButton disabled={!completed && !active} sx={{color: 'white', width: '100%', height: '100%', textShadow: completed || active ? '1px 1px 2px rgb(0, 0, 0)' : 'none'}}>3</IconButton>,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}